import { IconButton, Stack, Typography } from '@mui/material';
import moment from 'moment';

import { IcIncomingCall, IcInfoCircle } from '@/assets/images';
import { DATE_TIME_FORMAT_WITH_SECONDS } from '@/config';
import { useTimer } from '@/hooks';
import { ICall, IUser, Role } from '@/models';
import { isTargetRole } from '@/services';
import { useUserStore } from '@/store';
import { formatPersonName, formatPhoneNumber } from '@/utils';

import { CallCardRoot } from '../styles';

interface CallCardProps extends ICall {
  isNewCall?: boolean;
  onInfoIconClick?: () => void;
  disabled?: boolean;
}

export const CallCard = ({
  phoneNumber,
  provider,
  startedAt,
  isNewCall,
  onInfoIconClick,
  disabled,
  ...rest
}: CallCardProps) => {
  const { user } = useUserStore();
  const isActive =
    !rest.completedAt && rest.missed === false && rest.answeredAt !== undefined;

  let timer = undefined;

  if (isActive) {
    timer = useTimer(new Date(rest?.answeredAt || ''));
  }

  return (
    <CallCardRoot
      className={[isNewCall ? 'is-new-call' : '', disabled ? 'disabled' : '']
        .filter(Boolean)
        .join(' ')}
    >
      <IcIncomingCall
        className="svg-phone"
        color={rest.missed ? '#EE3E5C' : 'inherit'}
      />
      <Stack flex={1}>
        <Typography
          variant="subtitle2"
          className="call-number"
          color={rest.missed ? '#EE3E5C' : 'inherit'}
        >
          {formatPhoneNumber(phoneNumber)} - {rest?.callerName ?? 'Unknown'}
        </Typography>
        <Stack>
          <Typography className="call-info">
            {rest.handledBy && rest.missed === false
              ? `${formatPersonName(rest.handledBy)} - `
              : ''}
            {moment(startedAt).local().format(DATE_TIME_FORMAT_WITH_SECONDS)}
          </Typography>
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center">
        {timer && isActive && (
          <Typography variant="subtitle2">{timer.duration}</Typography>
        )}
        {isTargetRole(user as IUser, Role.CALL_LOG_ACCESS) && (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onInfoIconClick?.();
            }}
          >
            <IcInfoCircle color="#007AFF" />
          </IconButton>
        )}
      </Stack>
    </CallCardRoot>
  );
};
